export function CodeCard({ title, lines }: { title: string; lines: string[] }) {
  return (
    <div className="ps-card overflow-hidden">
      <div className="flex items-center gap-2 border-b border-ps-border bg-ps-chrome px-4 py-3">
        <span className="h-3 w-3 rounded-full bg-ps-accent" />
        <span className="h-3 w-3 rounded-full bg-ps-strong" />
        <span className="h-3 w-3 rounded-full bg-ps-border" />
        <span className="ml-2 text-xs text-ps-subtle">{title}</span>
      </div>
      <pre className="overflow-x-auto p-4 text-xs leading-[1.7] text-gray-300 sm:p-5 sm:text-[13px]">
        <code>{lines.join('\n')}</code>
      </pre>
    </div>
  );
}
